/**
 * New Supplement Grid JavaScript
 * Rebuilt from scratch with modern functionality
 */

document.addEventListener('DOMContentLoaded', function () {
  // Prebuilt stack flag utilities
  function initPrebuiltStackFlag() {
    try {
      var currentUrl = new URL(window.location.href);
      var urlFlag = currentUrl.searchParams.get('prebuilt_stack');
      var supplementFlag = currentUrl.searchParams.get('supplement');

      if (urlFlag === 'true' || urlFlag === 'false') {
        if (typeof window.sessionStorage !== 'undefined') {
          window.sessionStorage.setItem('prebuilt_stack', urlFlag);
        }
        currentUrl.searchParams.delete('prebuilt_stack');
      }

      if (supplementFlag === 'true' || supplementFlag === 'false') {
        if (typeof window.sessionStorage !== 'undefined') {
          // supplement=true => show supplements tab (index 0) => prebuilt_stack=false
          // supplement=false => show stacks tab (index 1) => prebuilt_stack=true
          var mapped = (supplementFlag === 'true') ? 'false' : 'true';
          window.sessionStorage.setItem('prebuilt_stack', mapped);
        }
        currentUrl.searchParams.delete('supplement');
      }

      // Only update URL once after handling both params
      if (window.location.href !== currentUrl.toString()) {
        window.history.replaceState({}, '', currentUrl.toString());
      }
    } catch (e) {
      // no-op
    }
  };

  initPrebuiltStackFlag()


  function isPrebuiltStackActive() {
    try {
      return (typeof window.sessionStorage !== 'undefined') && window.sessionStorage.getItem('prebuilt_stack') === 'true';
    } catch (e) {
      return false;
    }
  }
  // Function to preload all background images for smooth hover effects
  function preloadBackgroundImages() {
    // Supplement mouth images
    const supplementMouthImages = [
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/ashwagandha_mouth-min.png?v=1755157752',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/biotin_mouth-min.png?v=1755157751',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/calcium_mouth-min.png?v=1755157752',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/coq10_mouth-min.png?v=1755157752',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/folic_acid_mouth-min.png?v=1755157751',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/iron_mouth-min.png?v=1755157751',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/magnesium_mouth-min.png?v=1755157752',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/omega3_mouth-min.png?v=1755157752',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/probiotics_mouth-min.png?v=1755157752',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminb12_mouth-min.png?v=1755157751',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminb2_mouth-min.png?v=1755157752',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminb6_mouth-min.png?v=1755157751',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitaminc_mouth-min.png?v=1755157752',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitamind_mouth-min.png?v=1755157752',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/vitamine_mouth-min.png?v=1755157752',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/zinc_mouth-min.png?v=1755157751'
    ];

    // Box hover images
    const boxHoverImages = [
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sleep_stack_supplements_large-min.png?v=1758610965',
      'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fitness_stack_supplements_large-min.png?v=1758611477'
    ];

    // Combine all images
    const allImages = [...supplementMouthImages, ...boxHoverImages];

    // Preload all images
    allImages.forEach(imageUrl => {
      const img = new Image();
      img.src = imageUrl;
      img.onerror = () => console.warn('Failed to preload:', imageUrl);
    });

    console.log(`Preloading ${allImages.length} background images...`);
  }

  // Start preloading immediately
  preloadBackgroundImages();

  // Supplement data
  const supplementNames = [
    "Ashwagandha", "Biotin", "Calcium", "CoQ10", "Folic Acid", "Iron", 
    "Magnesium", "Omega 3", "Probiotics", "Vitamin B12", "Vitamin B2", 
    "Vitamin B6", "Vitamin C", "Vitamin D", "Vitamin E", "Zinc"
  ];

  // Function to get dynamic box names based on quiz completion
  function getBoxNames() {
    const baseBoxNames = ["Sleep", "Fitness"];
    
    // Check if quiz has been completed (customerEmail exists in localStorage)
    const customerEmail = localStorage.getItem('customerEmail');
    if (customerEmail) {
      // Add "Your Protocol" at the beginning if quiz is completed
      return ["Your Protocol", ...baseBoxNames];
    }
    
    return baseBoxNames;
  }

  // Product URLs
  const supplementUrls = {
    "Ashwagandha": "/products/ashwagandha",
    "Biotin": "/products/biotin",
    "Calcium": "/products/calcium",
    "CoQ10": "/products/coq10",
    "Folic Acid": "/products/folic-acid",
    "Iron": "/products/iron",
    "Magnesium": "/products/magnesium",
    "Omega 3": "/products/omega-3",
    "Probiotics": "/products/probiotics",
    "Vitamin B12": "/products/vitamin-b12",
    "Vitamin B2": "/products/vitamin-b2",
    "Vitamin B6": "/products/vitamin-b6",
    "Vitamin C": "/products/vitamin-c",
    "Vitamin D": "/products/vitamin-d",
    "Vitamin E": "/products/vitamin-e",
    "Zinc": "/products/zinc"
  };

  // Box data
  let boxData = {
    "Your Protocol": {
      name: "Your Protocol",
      supplements: [], // Will be populated dynamically from localStorage
      price: 0, // Will be calculated dynamically
      image: "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sachet-empty-card-min.png?v=1759741940",
      hoverImage: "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fitness_stack_supplements_large-min.png?v=1758611477",
      icon: "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/icon_fitness.png?v=1754469967",
      url: "/pages/recommendation", // instead of pages/your-protocol
      isCustom: true // Flag to identify this as the custom "Your Protocol"
    },
    "Sleep": {
      name: "Sleep Protocol",
      supplements: ["Magnesium", "Ashwagandha", "Vitamin B6", "Omega 3"],
      price: 89,
      image: "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sleep_stack_sachet_dark-min.png?v=1758610965",
      hoverImage: "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sleep_stack_supplements_large-min.png?v=1758610965",
      icon: "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/icon_sleep.png?v=1754469966",
      url: "/products/sleep-protocol"
    },
    "Fitness": {
      name: "Fitness Protocol", 
      supplements: ["Magnesium", "Ashwagandha", "Vitamin C", "Zinc"],
      price: 95,
      image: "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fitness_stack_sachet_dark-min.png?v=1758610965",
      hoverImage: "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fitness_stack_supplements_large-min.png?v=1758611477",
      icon: "https://cdn.shopify.com/s/files/1/0781/4522/4995/files/icon_fitness.png?v=1754469967",
      url: "/products/fitness-protocol"
    }
  };

  // Function to calculate "Your Protocol" data dynamically
  function calculateYourStackData() {
    const customerEmail = localStorage.getItem('customerEmail');
    if (!customerEmail) return null;
    
    // Get recommendations from localStorage
    const recommendations = localStorage.getItem('recommendation');
    let supplementNames = [];
    let parsedRecommendations = {};

    if (recommendations) {
      try {
        const parsedRecommendation = JSON.parse(recommendations);
        supplementNames = Object.keys(parsedRecommendation);
        parsedRecommendations = parsedRecommendation;
      } catch (e) {
        console.warn('Failed to parse recommendations from localStorage:', e);
      }
    }
    
    // Fallback to window.currentRecommendations if localStorage is empty
    if (supplementNames.length === 0 && parsedRecommendations) {
      supplementNames = Object.keys(parsedRecommendations);
    }
    
    if (supplementNames.length === 0) {
      console.warn('No supplement recommendations found for Your Protocol');
      return null;
    }
    
    // Calculate total price
    let totalPrice = 0;
    let currencyCode = 'SGD'; // Default to SGD
    if (window.Shopify?.currency?.active) {
      currencyCode = window.Shopify.currency.active;
    }
    
    supplementNames.forEach(supplementName => {
      if (typeof priceSupplementsConverted !== 'undefined' && priceSupplementsConverted[supplementName]) {
        let supplementPrice = priceSupplementsConverted[supplementName].DEFAULT; // Default fallback
        if (priceSupplementsConverted[supplementName][currencyCode]) {
          supplementPrice = priceSupplementsConverted[supplementName][currencyCode];
        }
        totalPrice += supplementPrice;
      }
    });
    
    // Extract top benefits from each supplement (similar to result-banner)
    const benefits = supplementNames.map(supplementName => {
      if (parsedRecommendations && parsedRecommendations[supplementName]) {
        return parsedRecommendations[supplementName][1][0]; // First benefit
      }
      return 'Health'; // Fallback benefit
    });
    
    // Update boxData with the current supplements
    if (boxData["Your Protocol"]) {
      boxData["Your Protocol"].supplements = supplementNames;
      boxData["Your Protocol"].price = totalPrice;
    }
    
    return {
      supplements: supplementNames,
      price: totalPrice,
      benefits: benefits,
      supplementCount: supplementNames.length
    };
  }

  // Function to create supplement card
  function createSupplementCard(name) {
    const benefits = supplementToGoalsL1L2_REFINED_short[name] || ["Health", "Wellness"];
    const url = supplementUrls[name] || "#";
    
    // Get current currency
    let currencyCode = 'SGD';
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      currencyCode = Shopify.currency.active;
    }
    
    const price = getFormattedPrice(name, false, currencyCode);
    
    return `
      <div class="msgrid-supplement-card card-external-shadow" data-supplement="${name}" data-product-url="${url}">
        <div class="msgrid-card-visual">
          <div class="msgrid-visual-background">
            <div class="msgrid-capsule-container">
              <img src="${pills_floating[name]}" 
                   alt="${name} capsule" class="msgrid-capsule-image">
            </div>
          </div>
        </div>
        
        <div class="msgrid-card-info">
          <div class="msgrid-card-top">
            <div class="product-name body-semibold-black font-20px" >${name}</div>
            <div class="dosage laptop body-medium-grey font-14px">${numberOfCapsules[name]} daily · ${doses[name]}${unit[name]}</div>
            <div class="dosage tiny body-medium-grey font-14px">${doses[name]}${unit[name]}</div>
            <div class="msgrid-benefit-tags" data-total-tags="${benefits.length}">
              ${benefits.map((benefit, index) => {
                // Get icon data from benefitsIcon dictionary
                const iconData = (typeof benefitsIcon !== 'undefined' && benefitsIcon[benefit]) ? benefitsIcon[benefit] : null;
                const iconName = iconData ? iconData.icon : 'circle';
                const iconColor = iconData ? iconData.color : '#25D366';
                
                return `<span class="msgrid-benefit-tag solid-tag-icon" 
                             data-tag-index="${index}" 
                             style="--icon-color-20: ${iconColor}33; --icon-color-40: ${iconColor}66; --icon-color-70: ${iconColor}B3; --icon-color-100: ${iconColor}; --icon-color: ${iconColor};">
                         <i data-lucide="${iconName}" class="icon"></i>
                         <span class="tag-text">${benefit}</span>
                       </span>`;
              }).join('')}
              ${benefits.length > 1 ? `<span class="msgrid-tag-count grey-tag" data-remaining-count="${benefits.length - 1}">+${benefits.length - 1}</span>` : ''}
            </div>
          </div>
          <div class="msgrid-card-footer">
            <div class="msgrid-card-price-details">
              <div class="msgrid-card-price">
                <span class="currency subsection-title-small-semibold">${price.prefix}</span>
                <span class="amount subsection-title-small-semibold">${price.value}</span>
                <span class="cents body-medium-grey font-10px ${currencyCode}" style="display: ${currencyCode === 'IDR' ? 'inline' : 'none'}">${price.suffix}</span>
              </div>
              <div class="body-medium-grey font-10px">per month</div>
            </div>
            <button class="add-to-box-btn secondary-button" data-supplement-name="${name}">+ Add</button>
          </div>
        </div>
      </div>
    `;
  }

  // Function to create box card
  function createBoxCard(boxName) {
    const box = boxData[boxName];
    if (!box) return '';
    
    let benefits, dosage, price, currencyCode;
    
    // Get current currency (used in both cases)
    currencyCode = 'SGD';
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      currencyCode = Shopify.currency.active;
    }
    
    // Handle "Your Protocol" specially
    if (boxName === "Your Protocol" && box.isCustom) {
      const yourStackData = calculateYourStackData();
      if (!yourStackData) return ''; // Don't show if no quiz data
      
      benefits = yourStackData.benefits;
      dosage = `${yourStackData.supplementCount} Supplements · 30 daily doses`;
      
      // Calculate price for Your Protocol
      let currencyPrefix = '$';
      let priceValue = yourStackData.price;
      let centsSuffix = '';
      
      switch (currencyCode) {
        case 'SGD':
        case 'AUD':
        case 'HKD': currencyPrefix = '$'; break;
        case 'MYR': currencyPrefix = 'RM'; break;
        case 'IDR': currencyPrefix = 'Rp'; priceValue = Math.floor(yourStackData.price / 1000); centsSuffix = 'k'; break;
        default: currencyPrefix = 'S$';
      }
      
      price = {
        prefix: currencyPrefix,
        value: priceValue,
        suffix: centsSuffix
      };
    } else {
      // Handle regular boxes
      benefits = (typeof boxBenefits !== 'undefined' && boxBenefits[boxName]) ? boxBenefits[boxName] : ["Health", "Wellness"];
      dosage = "4 Supplements · 30 daily doses";
      
      price = getFormattedPrice(boxName, true, currencyCode);
    }
    
    return `
      <div class="msgrid-supplement-card msgrid-box-card card-external-shadow" data-box="${boxName}" data-product-url="${box.url}" data-hover-image="${box.hoverImage}">
        ${boxName === "Your Protocol" ? `
          <div class="recommendation-completed-bubble">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
        ` : ''}
        <div class="msgrid-card-visual box">
          <div class="msgrid-visual-background msgrid-box-background">
            <div class="msgrid-capsule-container">
              <img src="${box.image}" alt="${box.name}" class="msgrid-capsule-image">
              ${boxName === "Your Protocol" ? `
                <div class="msgrid-supplement-overlay" id="msgrid-supplement-overlay-${boxName.replace(/\s+/g, '-').toLowerCase()}">
                  <!-- Supplement text will be dynamically added here -->
                </div>
              ` : ''}
            </div>
          </div>
        </div>
        
        <div class="msgrid-card-info box">
          <div class="msgrid-card-top">
            <div class="product-name body-semibold-black font-20px">${box.name}</div>
            <div class="dosage laptop-box body-medium-grey font-14px">${dosage}</div>
            <div class="dosage tiny-box body-medium-grey font-14px">30 daily doses</div>
            <div class="msgrid-benefit-tags" data-total-tags="${benefits.length}">
              ${benefits.map((benefit, index) => {
                // Get icon data from benefitsIcon dictionary
                const iconData = (typeof benefitsIcon !== 'undefined' && benefitsIcon[benefit]) ? benefitsIcon[benefit] : null;
                const iconName = iconData ? iconData.icon : 'circle';
                const iconColor = iconData ? iconData.color : '#25D366';
                
                return `<span class="msgrid-benefit-tag solid-tag-icon" 
                             data-tag-index="${index}" 
                             style="--icon-color-20: ${iconColor}33; --icon-color-40: ${iconColor}66; --icon-color-70: ${iconColor}B3; --icon-color-100: ${iconColor}; --icon-color: ${iconColor};">
                          <i data-lucide="${iconName}" class="icon"></i>
                          <span class="tag-text">${benefit}</span>
                        </span>`;
              }).join('')}
              ${benefits.length > 1 ? `<span class="msgrid-tag-count grey-tag" data-remaining-count="${benefits.length - 1}">+${benefits.length - 1}</span>` : ''}
            </div>
          </div>
          <div class="msgrid-card-footer">
            <div class="msgrid-card-price-details">
              <div class="msgrid-card-price">
                <span class="currency subsection-title-small-semibold">${price.prefix}</span>
                <span class="amount subsection-title-small-semibold">${price.value}</span>
                <span class="cents body-medium-grey font-10px ${currencyCode}" style="display: ${currencyCode === 'IDR' ? 'inline' : 'none'}">${price.suffix}</span>
              </div>
              <div class="body-medium-grey font-10px">per month</div>
            </div>
            <button class="add-to-box-btn secondary-button" data-box-name="${boxName}">+ Add</button>
          </div>
        </div>
      </div>
    `;
  }

  // Populate supplement grid
  const supplementContainer = document.getElementById("msgrid-supplement-grid");
  if (supplementContainer) {
    supplementContainer.innerHTML = "";
    supplementNames.forEach(supplement => {
      supplementContainer.innerHTML += createSupplementCard(supplement);
    });
    
    // Initialize Lucide icons after supplement cards are created
    if (typeof lucide !== 'undefined' && lucide.createIcons) {
      lucide.createIcons();
    }
  }

  // Populate box grid
  const boxContainer = document.getElementById("msgrid-supplement-box-grid");
  if (boxContainer) {
    boxContainer.innerHTML = "";
    const dynamicBoxNames = getBoxNames();
    dynamicBoxNames.forEach(box => {
      const boxCard = createBoxCard(box);
      if (boxCard) { // Only add if card was created (Your Protocol might return empty if no quiz data)
        boxContainer.innerHTML += boxCard;
      }
    });
  }

  // Navigation functionality (matching supp-what-to-expect behavior)
  const tabsWrap = document.getElementById("msgrid-tabs");
  const leftChevron = document.getElementById("msgrid-nav-chevron-left");
  const rightChevron = document.getElementById("msgrid-nav-chevron-right");
  const tabIndicator = document.getElementById("msgrid-tab-indicator");
  const supplementsSection = document.getElementById("msgrid-supplements-section");
  const boxesSection = document.getElementById("msgrid-boxes-section");
  const sections = [supplementsSection, boxesSection];

  // Create navigation buttons dynamically
  function createNavigationButtons() {
    const tabs = [
      { name: "Our Supplements", target: "supplements" },
      { name: "Our Protocols", target: "boxes" }
    ];
    
    return tabs.map((tab, index) => {
      // Add quiz completion bubble for "Our Protocol" tab
      if (tab.target === "boxes") {
        return `
          <button class="navigation-toggle-button msgrid-nav-button grey" 
                  data-index="${index}" data-tab="${tab.target}">
            ${tab.name}
            <div class="quiz-completed-bubble" id="quiz-completed-bubble" style="display: none;">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
          </button>
        `;
      }
      
      return `
        <button class="navigation-toggle-button msgrid-nav-button grey" 
                data-index="${index}" data-tab="${tab.target}">
          ${tab.name}
        </button>
      `;
    }).join('');
  }

  // Function to set consistent card heights based on first card
  function setConsistentCardHeights() {
    // Get the currently active section
    const activeSection = document.querySelector('.msgrid-section-one.active, .msgrid-section-two.active');
    if (!activeSection) return;
    
    // Get all cards in the active section
    const cards = activeSection.querySelectorAll('.msgrid-supplement-card');
    if (cards.length === 0) return;
    
    // For screens below 950px, reset card heights
    if (window.innerWidth < 950) {
      cards.forEach(card => {
        card.style.height = '';
      });
      return;
    }
    
    cards.forEach(card => {
      card.style.height = '';
    });
    // Get the height of the first card
    const firstCard = cards[0];
    const firstCardHeight = firstCard.offsetHeight;
    
    
    // Set max-height for all cards to match the first card
    cards.forEach((card, index) => {
      card.style.height = firstCardHeight + 'px';
    });
  }

    // Function to calculate optimal tag display using while loop approach
    function calculateOptimalTagDisplay(container) {
      const totalTags = parseInt(container.dataset.totalTags) || 0;
      if (totalTags <= 1) return { visibleTags: 1, showCount: false, remainingCount: 0 };
      
      // Get all tags and count element
      const allTags = container.querySelectorAll('.msgrid-benefit-tag');
      const countElement = container.querySelector('.msgrid-tag-count');
      
      if (allTags.length === 0) return { visibleTags: 1, showCount: false, remainingCount: 0 };
      
      // Temporarily show all tags to measure
      const originalStates = [];
      allTags.forEach((tag, index) => {
        originalStates[index] = {
          opacity: tag.style.opacity,
          visibility: tag.style.visibility
        };
        tag.style.opacity = '1';
        tag.style.visibility = 'visible';
      });
      
      // Measure container width and tag dimensions
      const containerWidth = container.offsetWidth;
      const tagGap = parseFloat(getComputedStyle(container).gap) || 8;
      
      // Calculate maximum tags per line dynamically by simulating line wrapping
      let maxTagsPerLine = 0;
      let currentLineWidth = 0;
      let currentLineTags = 0;
      
      for (let i = 0; i < allTags.length; i++) {
        const tag = allTags[i];
        const tagWidth = tag.offsetWidth;
        
        // Check if this tag fits on the current line
        if (currentLineWidth + tagWidth <= containerWidth) {
          currentLineWidth += tagWidth + tagGap;
          currentLineTags++;
        } else {
          // This tag doesn't fit, move to next line
          if (currentLineTags > maxTagsPerLine) {
            maxTagsPerLine = currentLineTags; // Update max tags per line
          }
          currentLineWidth = tagWidth + tagGap; // Start new line with this tag
          currentLineTags = 1;
        }
      }
      
      // Update max tags per line with the last line if it's the longest
      if (currentLineTags > maxTagsPerLine) {
        maxTagsPerLine = currentLineTags;
      }
      
      const tagsPerLine = maxTagsPerLine;
      
      // Calculate maximum tags that can fit in 2 lines without count
      const maxTagsInTwoLines = tagsPerLine * 2;
      
      let visibleTags = Math.min(totalTags, maxTagsInTwoLines);
      let remainingCount = totalTags - visibleTags;
      let showCount = false;
      
      // If we have remaining tags, we need to show count
      if (remainingCount > 0 && countElement) {
        // Temporarily show the count to measure its width
        countElement.style.opacity = '1';
        countElement.style.visibility = 'visible';
        const countWidth = countElement.offsetWidth;
        
        // While loop: keep adding tags until count would be pushed to line 3
        let testVisibleTags = 1; // Start with just first tag
        let canAddMore = true;
        
        while (canAddMore && testVisibleTags < totalTags) {
          // Test if we can add one more tag and still fit count on line 2
          const nextTagIndex = testVisibleTags;
          const nextTag = allTags[nextTagIndex];
          
          // Calculate which line the count would be on
          const tagsOnLine1 = Math.min(tagsPerLine, testVisibleTags);
          const tagsOnLine2 = Math.max(0, testVisibleTags - tagsPerLine);
          
          // If count would be on line 2, check if it fits
          if (tagsOnLine2 < tagsPerLine) {
            // Count would be on line 2, check if it fits with next tag
            const line2Tags = Array.from(allTags).slice(tagsPerLine, testVisibleTags);
            const line2Width = line2Tags.reduce((width, tag) => width + tag.offsetWidth + tagGap, 0);
            
            // Check if adding next tag and count would fit on line 2
            if (line2Width + nextTag.offsetWidth + tagGap + countWidth + tagGap <= containerWidth) {
              testVisibleTags++;
            } else {
              canAddMore = false;
            }
          } else {
            // Count would be on line 3, stop adding
            canAddMore = false;
          }
        }
        
        visibleTags = testVisibleTags;
        remainingCount = totalTags - visibleTags;
        showCount = remainingCount > 0;
      }
      
      // Restore original states
      allTags.forEach((tag, index) => {
        tag.style.opacity = originalStates[index].opacity || '';
        tag.style.visibility = originalStates[index].visibility || '';
      });
      
      if (countElement) {
        countElement.style.opacity = originalStates[0].opacity || '';
        countElement.style.visibility = originalStates[0].visibility || '';
      }
      
      return {
        visibleTags: Math.max(1, visibleTags),
        showCount: showCount && remainingCount > 0,
        remainingCount: Math.max(0, remainingCount)
      };
    }

    // Function to set dynamic tag heights and smart display
    function setDynamicTagHeights() {
      // Get the currently active section
      const activeSection = document.querySelector('.msgrid-section-one.active, .msgrid-section-two.active');
      if (!activeSection) return;
      
      // Get all benefit tags containers in the active section
      const tagContainers = activeSection.querySelectorAll('.msgrid-benefit-tags');
      if (tagContainers.length === 0) return;
      
      // For screens below 950px, reset tag heights and clear custom properties
      if (window.innerWidth < 950) {
        tagContainers.forEach(container => {
          container.style.setProperty('--tag-height-single', '');
          container.style.setProperty('--tag-height-double', '');
          container.style.maxHeight = '';
          container.style.transition = '';
        });
        return;
      }
      
      // Get the first tag container as reference
      const firstTagContainer = tagContainers[0];
      const firstTag = firstTagContainer.querySelector('.msgrid-benefit-tag');
      
      if (!firstTag) return;
      
      // Temporarily show all tags to measure height
      const allTags = firstTagContainer.querySelectorAll('.msgrid-benefit-tag');
      const originalOpacity = [];
      const originalVisibility = [];
      
      // Store original opacity/visibility states and show all tags
      allTags.forEach((tag, index) => {
        originalOpacity[index] = tag.style.opacity;
        originalVisibility[index] = tag.style.visibility;
        tag.style.opacity = '1';
        tag.style.visibility = 'visible';
      });
      
      // Measure the height of the first tag line
      const firstTagHeight = firstTag.offsetHeight;
      const tagGap = parseFloat(getComputedStyle(firstTagContainer).gap) || 8; // 0.5rem = 8px
      
      // Calculate heights
      const singleLineHeight = firstTagHeight;
      const twoLineHeight = (firstTagHeight * 2) + tagGap;
      
      
      // Restore original opacity/visibility states
      allTags.forEach((tag, index) => {
        tag.style.opacity = originalOpacity[index] || '';
        tag.style.visibility = originalVisibility[index] || '';
      });
      
      // Set heights and smart display for all tag containers
      tagContainers.forEach((container, index) => {
        // Set CSS custom properties for heights
        container.style.setProperty('--tag-height-single', singleLineHeight + 'px');
        container.style.setProperty('--tag-height-double', twoLineHeight + 'px');
        
        // Ensure transition is enabled
        container.style.transition = 'max-height 0.3s ease-in-out';
        
        // Calculate optimal display
        const optimalDisplay = calculateOptimalTagDisplay(container);
        
        // Set data attributes for hover behavior
        container.dataset.visibleTags = optimalDisplay.visibleTags;
        container.dataset.showCount = optimalDisplay.showCount;
        container.dataset.remainingCount = optimalDisplay.remainingCount;
      
      });
    }

  // Tab selection function
  async function selectTab(index) {
    // Persist selection in sessionStorage
    try {
      if (typeof window.sessionStorage !== 'undefined') {
        window.sessionStorage.setItem('prebuilt_stack', index === 1 ? 'true' : 'false');
        const event = new CustomEvent('changedShopPage', { detail: { tabIndex: index } });
        window.dispatchEvent(event);
      }
    } catch (e) {
      // no-op
    }
    
    // Check if the clicked tab is already active
    const currentActiveButton = tabsWrap.querySelector('.navigation-toggle-button.active');
    if (currentActiveButton && parseInt(currentActiveButton.dataset.index) === index) {
      return; // Do nothing if clicking the current tab
    }

    // Update button states immediately
    const buttons = document.querySelectorAll('.msgrid-nav-button');
    console.log('Found buttons:', buttons.length);
    
    buttons.forEach((btn, btnIndex) => {
      const shouldBeActive = btnIndex === index;
      btn.classList.toggle('active', shouldBeActive);
      console.log(`Button ${btnIndex}: active = ${shouldBeActive}, classes = ${btn.className}`);
    });

    // Update navigation functions immediately
    if (window.navigationFunctions) {
      window.navigationFunctions.updateTabIndicator(index);
      setTimeout(() => window.navigationFunctions.centerActiveButton(index), 100);
    }

    // Get current active section for fade-out
    const currentActiveSection = supplementsSection.classList.contains('active') ? supplementsSection : boxesSection;
    
    // Add fade-out class to current active section
    if (currentActiveSection) {
      currentActiveSection.classList.remove("animate--fade-in");
      currentActiveSection.classList.add("animate--fade-out");
    }

    // Wait for fade-out to complete (300ms) before showing new content
    await new Promise(resolve => setTimeout(resolve, 300));

    // Update section visibility
    if (index === 0) {
      // Show supplements section
      supplementsSection.classList.remove("animate--fade-out", "active");
      supplementsSection.classList.add("active");
      supplementsSection.style.display = 'block';
      supplementsSection.style.opacity = '0';
      await new Promise(resolve => setTimeout(resolve, 10));
      supplementsSection.classList.add("animate--fade-in");
      
      boxesSection.classList.remove("animate--fade-out", "active");
      boxesSection.style.display = 'none';
      
      console.log('Showing supplements section');
    } else {
      // Show boxes section
      boxesSection.classList.remove("animate--fade-out", "active");
      boxesSection.classList.add("active");
      boxesSection.style.display = 'block';
      boxesSection.style.opacity = '0';
      await new Promise(resolve => setTimeout(resolve, 10));
      boxesSection.classList.add("animate--fade-in");
      
      supplementsSection.classList.remove("animate--fade-out", "active");
      supplementsSection.style.display = 'none';
      
      console.log('Showing boxes section');
    }

    // Set consistent card heights and dynamic tag heights after content is displayed
    setTimeout(() => {
      setConsistentCardHeights();
      setDynamicTagHeights();
      
      // Initialize Lucide icons after content is displayed
      if (typeof lucide !== 'undefined' && lucide.createIcons) {
        lucide.createIcons();
      }
    }, 200); // Small delay to ensure content is rendered
  }

  // Function to check for quiz completion and show bubble
  function checkQuizCompletion() {
    const bubble = document.getElementById('quiz-completed-bubble');
    if (!bubble) {
      console.warn('⚠️ Quiz completion bubble not found');
      return;
    }
    
    // Check if customerEmail exists in localStorage (indicating quiz completion)
    const customerEmail = localStorage.getItem('customerEmail');
    
    if (customerEmail) {
      bubble.style.display = 'flex';
      console.log('✅ Quiz completion bubble shown - customerEmail found');
    } else {
      bubble.style.display = 'none';
      console.log('❌ Quiz completion bubble hidden - no customerEmail');
    }
  }
  
  // Listen for storage changes to update bubble in real-time
  function handleStorageChange(event) {
    if (event.key === 'customerEmail') {
      checkQuizCompletion();
      // Also refresh the box grid to show/hide Your Protocol card
      setTimeout(refreshBoxGrid, 100);
    }
  }
  
  // Add storage event listener
  window.addEventListener('storage', handleStorageChange);
  
  // Function to populate supplement overlay text on Your Protocol card image
  function populateMSGSupplementOverlay() {
    const overlay = document.getElementById('msgrid-supplement-overlay-your-protocol');
    if (!overlay) return;

    const recommendations = localStorage.getItem('recommendation');
    const supplementNames = Object.keys(JSON.parse(recommendations));
    overlay.innerHTML = '';

    supplementNames.forEach(supplementName => {
      const dose = doses[supplementName] || '0';
      const units = unit[supplementName] || 'mg';
      const doseText = `${dose}${units}`;
      
      const lineElement = document.createElement('div');
      lineElement.className = 'msgrid-supplement-line';
      
      const nameElement = document.createElement('span');
      nameElement.className = 'msgrid-supplement-name-sachet body-medium-black font-12px';
      nameElement.textContent = supplementName;
      
      const doseElement = document.createElement('span');
      doseElement.className = 'msgrid-supplement-dose-sachet body-medium-black font-12px';
      doseElement.textContent = doseText;
      
      lineElement.appendChild(nameElement);
      lineElement.appendChild(doseElement);
      overlay.appendChild(lineElement);
    });
  }

  // Function to refresh box grid when quiz data changes
  function refreshBoxGrid() {
    const boxContainer = document.getElementById("msgrid-supplement-box-grid");
    if (boxContainer) {
      boxContainer.innerHTML = "";
      const dynamicBoxNames = getBoxNames();
      dynamicBoxNames.forEach(box => {
        const boxCard = createBoxCard(box);
        if (boxCard) {
          boxContainer.innerHTML += boxCard;
        }
      });
      
      // Re-initialize Lucide icons after refreshing
      if (typeof lucide !== 'undefined' && lucide.createIcons) {
        lucide.createIcons();
      }
      
      // Re-setup card heights and other functionality
      setTimeout(() => {
        setConsistentCardHeights();
        setDynamicTagHeights();
        setupSmartTagHover();
        setupMobileTagVisibility();
        setupTinyScreenCountPositioning();
        
        // Populate overlay for Your Protocol card if it exists
        populateMSGSupplementOverlay();
      }, 100);
    }
  }

  // Populate navigation buttons
  if (tabsWrap) {
    tabsWrap.innerHTML = createNavigationButtons();
  }

  // Set initial section visibility based on stored flag
  var initialTabIndex = isPrebuiltStackActive() ? 1 : 0;
  if (supplementsSection && boxesSection) {
    if (initialTabIndex === 0) {
      supplementsSection.classList.add('active');
      supplementsSection.style.display = 'block';
      boxesSection.classList.remove('active');
      boxesSection.style.display = 'none';
    } else {
      boxesSection.classList.add('active');
      boxesSection.style.display = 'block';
      supplementsSection.classList.remove('active');
      supplementsSection.style.display = 'none';
    }
  }

  // Set initial consistent card heights and dynamic tag heights after content is loaded
  setTimeout(() => {
    setConsistentCardHeights();
    setDynamicTagHeights();
    
    // Initialize Lucide icons after initial content is loaded
    if (typeof lucide !== 'undefined' && lucide.createIcons) {
      lucide.createIcons();
    }
  }, 100); // Small delay to ensure all content is rendered

  // Set up navigation with the reusable functions (after elements are created)
  setTimeout(() => {

    initPrebuiltStackFlag();

    const buttons = document.querySelectorAll('.msgrid-nav-button');
    
    // Set initial active button based on stored flag
    if (buttons.length > 0) {
      buttons.forEach(btn => btn.classList.remove('active'));
      const idx = isPrebuiltStackActive() ? 1 : 0;
      if (buttons[idx]) buttons[idx].classList.add('active');
    }
    
    // Create tabs array for navigation functions
    const tabs = Array.from(buttons).map((btn, idx) => ({
      element: btn,
      index: idx
    }));

    // Set up navigation with the reusable functions
    const navigationFunctions = setupNavigation({
      tabsContainer: tabsWrap,
      tabIndicator: tabIndicator,
      leftChevron: leftChevron,
      rightChevron: rightChevron,
      items: tabs,
      selectTabCallback: selectTab
    });

    // Add click listeners to tab buttons
    buttons.forEach((button, index) => {
      button.addEventListener('click', function() {
        selectTab(index);
      });
    });

    // Initial setup: set indicator based on stored flag
    setTimeout(() => {
      if (navigationFunctions) {
        const idx = isPrebuiltStackActive() ? 1 : 0;
        navigationFunctions.updateTabIndicator(idx);
      }
    }, 50);

    // Store navigationFunctions globally for use in selectTab
    window.navigationFunctions = navigationFunctions;
    
    // Check for quiz completion and show bubble
    checkQuizCompletion();
  }, 100);

  // Add click event listeners to supplement cards for navigation
  document.addEventListener('click', function(e) {
    const supplementCard = e.target.closest('.msgrid-supplement-card');
    if (supplementCard && !e.target.closest('.add-to-box-btn')) {
      const productUrl = supplementCard.getAttribute('data-product-url');
      if (productUrl && productUrl !== '#') {
        window.location.href = productUrl;
      }
    }
  });

  // Function to update button state based on cart
  function updateButtonState(button, isInCart) {
    const supplementName = button.getAttribute('data-supplement-name');
    
    const boxName = button.getAttribute('data-box-name');
    const isTinyScreen = window.innerWidth <= 375;
    
    // Get the card element to add/remove the "added" class
    const card = button.closest('.msgrid-supplement-card');
    
    if (isInCart) {
      // Add "added" class to card for green border effect
      if (card) {
        card.classList.add('added');
      }
      
      // Hide the button
      button.style.display = 'none';
      
      // Check if added tag already exists
      let addedTag = button.parentNode.querySelector('.msgrid-added-tag');
      
      if (!addedTag) {
        // Create and add the "Added" tag as a sibling to the button
        addedTag = document.createElement('span');
        addedTag.className = 'msgrid-added-tag';
        addedTag.innerHTML = `
          <i data-lucide="check" class="icon"></i>
          <span class="added-text body-medium-black font-16px">Added</span>
        `;
        
        // Insert the added tag after the button
        button.parentNode.insertBefore(addedTag, button.nextSibling);
        
        // Initialize Lucide icons for the new element
        if (typeof lucide !== 'undefined' && lucide.createIcons) {
          lucide.createIcons();
        }
      } else {
        // Show the existing added tag
        addedTag.style.display = 'inline-flex';
      }
    } else {
      // Remove "added" class from card to remove green border effect
      if (card) {
        card.classList.remove('added');
      }
      
      // Show the button and hide the added tag
      button.style.display = '';
      button.disabled = false;
      
      // Ensure button shows correct text based on screen size
      button.textContent = isTinyScreen ? '+' : '+ Add';
      
      // Hide the added tag if it exists
      const addedTag = button.parentNode.querySelector('.msgrid-added-tag');
      if (addedTag) {
        addedTag.style.display = 'none';
      }
    }
  }

  // Function to update all button states based on current cart
  function updateAllButtonStates() {
    const buttons = document.querySelectorAll('.add-to-box-btn');
    
    // Pre-calculate box states for efficiency using local boxData
    const boxStates = {};
    Object.keys(boxData).forEach(boxName => {
      const box = boxData[boxName];
      if (box && box.supplements) {
        boxStates[boxName] = box.supplements.every(supplementName => 
          window.currentSupplementCart[supplementName]
        );
      }
    });
    
    buttons.forEach(button => {
      const supplementName = button.getAttribute('data-supplement-name');
      const boxName = button.getAttribute('data-box-name');
      
      if (supplementName) {
        // Check if supplement is in cart
        updateButtonState(button, !!window.currentSupplementCart[supplementName]);
      } else if (boxName) {
        // Use pre-calculated box state
        updateButtonState(button, boxStates[boxName] || false);
      }
    });
  }

  // Function to show loading state on button
  function showButtonLoading(button) {
    const originalText = button.textContent;
    button.disabled = true;
    
    // Add CSS animation if not already added (matching cart-drawer approach)
    if (!document.getElementById('loading-spinner-styles')) {
      const style = document.createElement('style');
      style.id = 'loading-spinner-styles';
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
    
    // Create loading spinner matching cart-drawer approach
    button.innerHTML = '<div style="display:block !important; width: 16px; height: 16px; border: 2px solid #ccc; border-top: 2px solid #1d1d1d; border-radius: 50%; animation: spin 1s linear infinite;"></div>';
    
    // Reset after 2 seconds
    setTimeout(() => {
      const isTinyScreen = window.innerWidth <= 375;
      button.textContent = isTinyScreen ? '+' : '+ Add';
      button.disabled = false;
      button.innerHTML = button.textContent;
    }, 3000);
  }

  
  // Add to cart functionality using global functions
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('add-to-box-btn')) {
      e.preventDefault();
      e.stopPropagation();
      
      const button = e.target;
      const supplementName = button.getAttribute('data-supplement-name');
      const boxName = button.getAttribute('data-box-name');
      
      // Show loading state immediately
      showButtonLoading(button);
      
      // Call global functions for adding to cart
      if (supplementName) {
        // Add individual supplement to cart
        if (typeof globalAddSupplementToCart !== 'undefined') {
          globalAddSupplementToCart(supplementName, null, "Adding...", "Added", "addToCartFromShopAll", true);
        }
      } else if (boxName) {
        // Add box to cart
        if (typeof globalAddBoxToCart !== 'undefined') {
          globalAddBoxToCart(boxName, null, "Adding...", "Added", "All Items in Stack", "addToCartFromShopAll", true);
        }
      }
    }
  });

  // Listen for cart changes and update button states
  window.addEventListener('cartChangedDelayed', function() {
    console.log('📢 Cart change event received by supplement grid');
    updateAllButtonStates();
  });

  // Initial button state update after content is loaded
  setTimeout(() => {
    updateAllButtonStates();
    refreshBoxGrid();
  }, 200);

   // Add smart hover behavior for benefit tags (only on screens 950px and above)
   function setupSmartTagHover() {
     // Only set up hover behavior on screens 950px and above
     if (window.innerWidth < 950) {
       return;
     }
     
     const cards = document.querySelectorAll('.msgrid-supplement-card');
     
     cards.forEach(card => {
      const tagContainer = card.querySelector('.msgrid-benefit-tags');
      if (!tagContainer) return;
      
      const countElement = tagContainer.querySelector('.msgrid-tag-count');
      const countWidth = countElement ? countElement.offsetWidth : 0;
      const allTags = tagContainer.querySelectorAll('.msgrid-benefit-tag');
      
      // Set initial order state: T1 at position 0, +n at position 1, others after
      allTags.forEach((tag, index) => {
        if (index === 0) {
          tag.style.order = '0'; // First tag at position 0
        } else {
          tag.style.opacity = '0';
          tag.style.visibility = 'hidden';
          tag.style.order = index + 1; // Other tags after count position
        }
      });
      
      if (countElement) {
        const totalTags = parseInt(tagContainer.dataset.totalTags) || 1;
        countElement.textContent = `+${totalTags - 1}`;
        countElement.style.order = '1'; // Count at position 1
      }
      
      card.addEventListener('mouseenter', () => {
        const totalTags = parseInt(tagContainer.dataset.totalTags) || 1;
        
        // Immediately hide count by moving it to the end
        if (countElement) {
          countElement.style.transition = 'none'; // Force instant transition
          countElement.style.opacity = '0';
          countElement.style.visibility = 'hidden';
          countElement.style.order = '999'; // Move count to the end to hide it quickly
          // Restore transition after a frame
          requestAnimationFrame(() => {
            countElement.style.transition = '';
          });
        }
        
        // Calculate how many tags fit per line
        const containerWidth = tagContainer.offsetWidth;
        const tagGap = parseFloat(getComputedStyle(tagContainer).gap) || 8;
        
        // Temporarily show all tags to measure
        allTags.forEach((tag, index) => {
          tag.style.opacity = '1';
          tag.style.visibility = 'visible';
        });
        
        // Calculate maximum tags per line dynamically by simulating line wrapping
        let maxTagsPerLine = 0;
        let currentLineWidth = 0;
        let currentLineTags = 0;
        
        for (let i = 0; i < allTags.length; i++) {
          const tag = allTags[i];
          const tagWidth = tag.offsetWidth;
          
          // Check if this tag fits on the current line
          if (currentLineWidth + tagWidth <= containerWidth) {
            currentLineWidth += tagWidth + tagGap;
            currentLineTags++;
          } else {
            // This tag doesn't fit, move to next line
            if (currentLineTags > maxTagsPerLine) {
              maxTagsPerLine = currentLineTags; // Update max tags per line
            }
            currentLineWidth = tagWidth + tagGap; // Start new line with this tag
            currentLineTags = 1;
          }
        }
        
        // Update max tags per line with the last line if it's the longest
        if (currentLineTags > maxTagsPerLine) {
          maxTagsPerLine = currentLineTags;
        }
        
        const tagsPerLine = maxTagsPerLine;
        
        // Temporarily show count to measure its width
        if (countElement) {
          countElement.style.opacity = '1';
          countElement.style.visibility = 'visible';
        }
        const countWidth = countElement ? countElement.offsetWidth : 0;
        
        // Function to check if k tags can be displayed with +n count on line 2
        function checkNumberTags(k) {
          // If k is 0 or negative, return false
          if (k <= 0) return false;
          
          // Simulate the actual layout by calculating positions
          let line1Width = 0;
          let line2Width = 0;
          let currentLine = 1;
          
          // Place each tag and calculate which line it ends up on
          for (let i = 0; i < k; i++) {
            const tag = allTags[i];
            const tagWidth = tag.offsetWidth;
            
            if (currentLine === 1) {
              // Try to place tag on line 1
              if (line1Width + tagWidth <= containerWidth) {
                line1Width += tagWidth + tagGap;
              } else {
                // Tag doesn't fit on line 1, move to line 2
                currentLine = 2;
                line2Width = tagWidth + tagGap;
              }
            } else {
              // Place tag on line 2
              line2Width += tagWidth + tagGap;
            }
          }
          
          
          // Check if +n count fits on line 2

          const countFitsOnLine2 = line2Width + (k >= totalTags ? -tagGap : countWidth) <= containerWidth;
          
      
          // Return true if either all tags are displayed OR count fits on line 2
          return countFitsOnLine2;
        }
        
        // Find the maximum number of tags we can display
        let visibleTagsCount = 1; // Start with at least 1 tag
        let showCount = true;
        
        // Keep increasing k until checkNumberTags returns false
        for (let k = 1; k <= totalTags; k++) {
          if (checkNumberTags(k)) {
            visibleTagsCount = k;
            if (k >= totalTags) {
              // All tags fit, no need for count
              showCount = false;
              break;
            }
          } else {
            // k tags don't fit, so we can display k-1 tags
            visibleTagsCount = k - 1;
            break;
          }
        }
        
        // Calculate count position and extra tags
        const countPosition = visibleTagsCount;
        const extraTagsCount = totalTags - visibleTagsCount;
        
        // Set order and visibility for all elements according to the algorithm
        allTags.forEach((tag, index) => {
          if (index === 0) {
            // Tag 0 always at order 0 and visible
            tag.style.order = '0';
            tag.style.opacity = '1';
            tag.style.visibility = 'visible';
          } else if (index < visibleTagsCount) {
            // Visible tags get their natural order (1, 2, 3, etc.)
            tag.style.order = index;
            tag.style.opacity = '1';
            tag.style.visibility = 'visible';
          } else {
            // Hidden tags get order after visible tags
            tag.style.order = index + 1;
            tag.style.opacity = '0';
            tag.style.visibility = 'hidden';
          }
        });
        
        // Update count with +extraTagsCount text
        if (countElement) {
          if (showCount && extraTagsCount > 0) {
            countElement.textContent = `+${extraTagsCount}`;
            countElement.style.order = countPosition;
            countElement.style.opacity = '1';
            countElement.style.visibility = 'visible';
            countElement.classList.remove('hide-count');
            countElement.classList.add('show-count');
          } else {
            countElement.style.opacity = '0';
            countElement.style.visibility = 'hidden';
            countElement.classList.remove('show-count');
            countElement.classList.add('hide-count');
            countElement.style.order = '999';
          }
        }
      });
      
      card.addEventListener('mouseleave', () => {
        // Reset to default state: show only first tag + count at position 1
        allTags.forEach((tag, index) => {
          if (index === 0) {
            tag.style.opacity = '1';
            tag.style.visibility = 'visible';
            tag.style.order = '0'; // First tag at position 0
          } else {
            tag.style.opacity = '0';
            tag.style.visibility = 'hidden';
            tag.style.order = index + 1; // Other tags after count position
          }
        });
        
        // Reset count to show original count at position 1
        if (countElement) {
          const totalTags = parseInt(tagContainer.dataset.totalTags) || 1;
          countElement.textContent = `+${totalTags - 1}`;
          countElement.style.order = '1'; // Count at position 1
          countElement.style.opacity = '1'; // Make sure count is visible
          countElement.style.visibility = 'visible'; // Make sure count is visible
          countElement.classList.remove('hide-count', 'show-count');
        }
      });
    });
  }

   // Function to handle mobile tag visibility (hide order 2+ tags on mobile)
   function setupMobileTagVisibility() {
     const cards = document.querySelectorAll('.msgrid-supplement-card');
     
     cards.forEach(card => {
       const tagContainer = card.querySelector('.msgrid-benefit-tags');
       if (!tagContainer) return;
       
       const allTags = tagContainer.querySelectorAll('.msgrid-benefit-tag');
       const countElement = tagContainer.querySelector('.msgrid-tag-count');
       
       // On screens below 950px, hide tags with index > 0 and count element
       if (window.innerWidth < 950) {
         allTags.forEach((tag, index) => {
           if (index === 0) {
             tag.style.display = 'inline-flex'; // Show first tag only
             tag.style.opacity = '1';
             tag.style.visibility = 'visible';
           } else {
             tag.style.display = 'none'; // Hide tags with index > 0
             tag.style.opacity = '0';
             tag.style.visibility = 'hidden';
           }
         });
         
         // Hide count element on screens below 950px
         if (countElement) {
           countElement.style.display = 'inline-flex';
           countElement.style.opacity = '1';
           countElement.style.visibility = 'visible';
         }
       } else {
         // On screens 950px and above, show all tags and count
         allTags.forEach(tag => {
           tag.style.display = 'inline-flex';
           // Don't reset opacity/visibility as they're controlled by hover logic
         });
         
         if (countElement) {
           countElement.style.display = 'inline-block';
           // Don't reset opacity/visibility as they're controlled by hover logic
         }
       }
     });
   }

   // Function to handle very small screens (below 345px) - apply column layout
   function setupTinyScreenCountPositioning() {
     const cards = document.querySelectorAll('.msgrid-supplement-card');
     
     // Handle button text change at 375px
     const buttons = document.querySelectorAll('.add-to-box-btn');
     if (window.innerWidth <= 375) {
       buttons.forEach(button => {
         button.textContent = '+';
       });
     } else {
       buttons.forEach(button => {
         button.textContent = '+ Add';
       });
     }
     
     // Handle column layout at 345px
     if (window.innerWidth <= 345) {
       // Apply column layout for screens below 345px
       cards.forEach(card => {
         const tagContainer = card.querySelector('.msgrid-benefit-tags');
         if (!tagContainer) return;
         
         const allTags = tagContainer.querySelectorAll('.msgrid-benefit-tag');
         const countElement = tagContainer.querySelector('.msgrid-tag-count');
         
         if (allTags.length > 0 && countElement) {
           // Change container to column layout
           tagContainer.style.flexDirection = 'column';
           tagContainer.style.flexWrap = 'nowrap';
           tagContainer.style.alignItems = 'center';
           
           // Show only first tag and count
           allTags.forEach((tag, index) => {
             if (index === 0) {
               tag.style.display = 'inline-flex';
               tag.style.order = '0';
               tag.style.width = 'fit-content';
             } else {
               tag.style.display = 'none';
               tag.style.order = index + 1;
             }
           });
           
           countElement.style.order = '1';
           countElement.style.display = 'inline-block';
           countElement.style.width = 'fit-content';
         }
       });
     } else {
       // Reset to normal layout for screens 345px and above
       cards.forEach(card => {
         const tagContainer = card.querySelector('.msgrid-benefit-tags');
         if (!tagContainer) return;
         
         // Reset container styles
         tagContainer.style.flexDirection = '';
         tagContainer.style.flexWrap = '';
         tagContainer.style.alignItems = '';
         
         const allTags = tagContainer.querySelectorAll('.msgrid-benefit-tag');
         const countElement = tagContainer.querySelector('.msgrid-tag-count');
         
         // Reset tag and count styles
         allTags.forEach((tag, index) => {
           tag.style.width = '';
           if (index >= 1) {
             tag.style.display = window.innerWidth <= 950 ? 'none' : 'inline-flex';
           }
         });
         
         if (countElement) {
           countElement.style.width = '';
           countElement.style.display = '';
         }
       });
     }
   }

   // Setup smart hover behavior and mobile visibility after initial setup
   setTimeout(() => {
     setupSmartTagHover();
     setupMobileTagVisibility();
     setupTinyScreenCountPositioning();
   }, 200);

   // Re-setup on window resize
   window.addEventListener('resize', () => {
     setTimeout(() => {
       setupSmartTagHover();
       setupMobileTagVisibility();
       setupTinyScreenCountPositioning();
       setConsistentCardHeights();
       setDynamicTagHeights();
       updateAllButtonStates(); // Update button states on resize
     }, 100);
   });

});
